module.exports = __webpack_public_path__ + "static/media/blynksolve.bd02f478.jpg";